import styles from './LogoLink.module.scss';

import logoImage from 'images/icons/clover-logo.svg';
import markImage from 'images/icons/clover-mark.svg';

import cx from 'classnames';
import { Image } from 'components/Image/Image';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import type { Link, LinkProps } from 'react-router-dom';
import { LocaleLink } from '../ContentLink/LocaleLink';
import { LOGO_LINK_TEST_ID } from 'components/LogoLink/LogoLink.const';

type Props = Pick<LinkProps, Exclude<keyof LinkProps, 'to' | 'role' | 'title'>> & {
  markOnly?: boolean;
  cloverLogo?: string;
};

const LogoLink = React.forwardRef<Link, WithTranslation & Props>(
  ({ markOnly, cloverLogo, t, i18n, tReady, className, ...props }, ref) => {
    let logo = markOnly ? markImage : logoImage;
    if (cloverLogo) logo = cloverLogo;

    return (
      <>
        <LocaleLink
          to="/"
          title={t('clover')}
          aria-label={t('clover')}
          className={cx(styles.logo, className)}
          data-testid={LOGO_LINK_TEST_ID.logo}
          innerRef={ref as React.Ref<HTMLAnchorElement>}
          {...props}
        >
          <Image src={logo} alt={t('clover')} />
        </LocaleLink>
      </>
    );
  },
);

const Translated = withTranslation()(LogoLink);

export { Translated as LogoLink };
